/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Restore_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Restore Selected Event Groups" |
*
* @param {Automatic_Save_Restore_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_aria_label = /** @type {((inputs?: Automatic_Save_Restore_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer les groupes d’événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisgruppen wiederherstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina gruppi di eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить выбранные группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar grupos de eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复选定的事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントグループを復元")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूहों को पुनर्स्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar grupos de eventos selecionados")
	return /** @type {LocalizedString} */ ("Restore Selected Event Groups")
});